import CircularProgress from '@mui/material/CircularProgress'
import { Typography, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Grow from '@mui/material/Grow'
import Box from '@mui/material/Box'
import React from 'react'

import { useStatisticsQuery } from 'shared/store/useStatistics'
import useAccountLimits from 'shared/store/useAccountLimits'
import BannersSlider from 'shared/components/BannersSlider'

import PointsAndSavedTime from './components/PointsAndSavedTime'
import ShoppingChart from './components/ShoppingChart'
import ActiveCart from './components/ActiveCart'
import Features from './components/Features'
import { en, pl, de } from './locales'
import { Grid } from './styles'

export default function Homepage() {
   const { i18n } = useTranslation()
   const theme = useTheme()
   const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
   const { data, isLoading, isError } = useStatisticsQuery()
   const { data: accountLimits } = useAccountLimits()

   i18n.addResourceBundle('pl-PL', 'HOMEPAGE', pl)
   i18n.addResourceBundle('en-EN', 'HOMEPAGE', en)
   i18n.addResourceBundle('de-DE', 'HOMEPAGE', de)

   return (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
         }}
      >
         {accountLimits && accountLimits.searchesLimit && (
            <Box
               sx={{
                  p: '0px 12px 12px 12px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
               }}
            >
               <Typography variant="h5">
                  {`Wyszukiwania w tym miesiącu: ${accountLimits.currentSearchCount}/${accountLimits.searchesLimit}`}
               </Typography>
            </Box>
         )}

         {data && !isLoading ? (
            <Box
               sx={{
                  display: 'flex',
                  width: '100%',
                  flexDirection: 'column',
                  gap: '25px',
               }}
            >
               <Box
                  sx={{
                     display: 'flex',
                     gap: '25px',
                     width: '100%',
                     flexDirection: { lg: 'row', md: 'column', xs: 'column' },
                     flexWrap: 'wrap',
                     minHeight: { lg: 350 },
                  }}
               >
                  <ActiveCart />
                  {!isMobile && (
                     <Grow in timeout={1000}>
                        <Box flex={1}>
                           <BannersSlider variant="HOMEPAGE" />
                        </Box>
                     </Grow>
                  )}
               </Box>
               <Box
                  sx={{
                     flexGrow: 1,
                  }}
               >
                  <ShoppingChart
                     formattedCurrency={data.spentMoney.formattedCurrency}
                     chartData={data.spentMoney}
                     statsFailed={isError}
                  />
               </Box>
               <Box sx={{ display: 'flex', flexDirection: { lg: 'row', md: 'column', xs: 'column' }, gap: '25px' }}>
                  <Box
                     sx={{
                        flexBasis: { lg: '33%', md: '100%', xs: '100%' },
                        flexGrow: 1,
                     }}
                  >
                     <PointsAndSavedTime savedTime={data.savedTime} statsFailed={isError} />
                  </Box>

                  <Box
                     sx={{
                        flexBasis: { lg: '66%', md: '100%', xs: '100%' },
                        flexGrow: 1,
                     }}
                  >
                     <Features />
                  </Box>
               </Box>
            </Box>
         ) : (
            <CircularProgress />
         )}
      </Box>
   )
}
